import axios from "axios";
import { API_CONFIG } from "../constants";

export async function authorization(googleResponse: any) {
  const token = localStorage.getItem("NT_TOKEN");
  return await axios.post(`${API_CONFIG.URL}/authorization`, googleResponse, {
    headers: { "X-Auth-Token": token! },
  });
}
